/**
 * 全局引用
 * @returns {*}
 */
import { Toast, Dialog } from "vant";
import moment from "moment";
import { apiAxios } from './http.js'
import config from "../config/systemConfig";
/**
 * setStorage 存储
 * getStorage 取到
 * removeStorage 移除
 */
export const storage = {
    setStorage: (name, val) => {
        try {
            const obj = JSON.stringify(val);
            localStorage.setItem(name, obj);
        } catch (e) {
            localStorage.setItem(name, val);
        }
    },

    getStorage: (val) => {
        let str = localStorage.getItem(val);
        if (str) {
            try {
                const obj = JSON.parse(str);
                return obj;
            } catch (e) {
                return str;
            }
        } else {
            return null;
        }
    },
    removeStorage: (val) => {
        localStorage.removeItem(val);
    },
};

/**
 * 输出方法
 */
export default {
    hasRight(user, url) {
        let right = 0;
        if ((user.leader === 1 || user.roleType === 0)) {
            right = 1
        }
        // 如果对这个功能有编辑权限
        let models = user.accessModules;
        for (let i = 0; i < models.length; i++) {
            if (models[i].uri && models[i].uri.indexOf(url) > -1) {
                // 找到
                let access = models[i].accessModel;
                if (access.length > 0 && access.charAt(1) > '0') {
                    right = 1;
                }
                break;
            }
        }
        return right;
    },
    setStorage: (name, val) => {
        storage.setStorage(name, val);
    },
    getStorage: (val) => {
        return storage.getStorage(val);
    },
    removeStorage: (val) => {
        storage.removeStorage(val);
    },
    // 请求去重,某些请求需要去重，避免客户双击引起数据重复
    distinct (url, func) {
        let name = "distinctUrl";
        // 缓存的数据
        let ses = sessionStorage.getItem(name);
        // 时间间隔，3秒一次
        let space = 300;
        if (!ses) {
            // 数据不存在，添加数据，执行函数
            sessionStorage.setItem(name, url + ";" + new Date().getTime());
            func();
        } else {
            // 数据存在，看是否过了时间
            let data = ses.split(";");
            if (url === data[0]) {
                // 是url，看时间
                if (new Date().getTime() - data[1] > space) {
                    // 缓存的不是这个url，执行
                    sessionStorage.setItem(name, url + ";" + new Date().getTime());
                    func();
                }
            } else {
                // 缓存的不是这个url，执行
                sessionStorage.setItem(name, url + ";" + new Date().getTime());
                func();
            }
        }
    },
    // 获取登录用户信息
    async getUserInfo() {
        try{
            let user = storage.getStorage("user");
            if (user) {
                return user;
            }
            // 没有数据，重新获取

            const data = await apiAxios(
                "/basedata/common/getUserInfo",
                {},"get"
            );
            // 把获取到的data转成对象
            storage.setStorage("user", data);
            // 缓存数据
            return data;
        } catch (e) {
            return {};
        }
    },
    install: function(Vue, options) {
        /**
         * Toast 弹出
         */
        Vue.prototype.Toast = function(title = "提示") {
            Toast.allowMultiple();
            Toast({
                mask: false, //是否显示蒙版
                message: title,
            });
        };
        /**
         * Dialog 弹出
         * @param {*} title
         * @param {*} message
         * @param {*} etc
         */
        Vue.prototype.Dialog = function(
            title = "提示",
            message,
            callback,
            showCancelButton = false
        ) {
            Dialog.confirm({
                    title: title,
                    message: message,
                    showCancelButton: showCancelButton, //取消按钮
                })
                .then(() => {
                    if (callback) {
                        callback();
                    }
                })
                .catch(() => {
                    // on cancel
                });
        };

        /**
         * loading 显示
         * @param {*} title
         */
        Vue.prototype.showLoad = function(title = "加载中", duration = 2000) {
            Toast.loading({
                mask: true,
                message: title,
                duration: duration, //当前显示时间
                forbidClick: true, //禁止点击背景
            });
        };

        /**
         * 初始化用户登录登录
         * @param {*}
         */
        Vue.prototype.getLogin = function(callback, code) {
            if (storage.getStorage("user")) {
                return false;
            }
            let parmas = {
                code: code ? code : this.$route.query.code,
            };
            this.$http("/basedata/base/loginByCode", parmas, "get", false).then(
                (res) => {
                    storage.setStorage("user", res);
                    if (callback) {
                        callback(res);
                    }
                }
            );
        };
        /**
         * 初始化微信配置
         * @param {*}
         */
        Vue.prototype.wxLogin = function(callback, jsApiList) {
            let ref = window.location.href;
            this.$http(
                "/basedata/common/getSignature", { refer: ref },
                "get",
                false
            ).then((res) => {
                let corpId = config.corpId;
                let conf = {
                    beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.corpId, // 必填，企业微信的corpID
                    timestamp: res.timeStamp, // 必填，生成签名的时间戳
                    nonceStr: res.nonceStr, // 必填，生成签名的随机串
                    signature: res.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
                    ticket: res.ticket,
                    url: ref,
                    jsApiList: ["checkJsApi", "agentConfig"], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
                };
                wx.config(conf);
                wx.error(function(res) {
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    console.log("config异常")
                    console.log(res)
                    console.log(conf)
                });
                wx.ready(() => {
                    this.$http(
                        "/basedata/common/getAgentSignature", { refer: ref },
                        "get",
                        false
                    ).then(agentRes => {
                        wx.agentConfig({
                            corpid: agentRes.corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
                            agentid: agentRes.agentId, // 必填，企业微信的应用id
                            timestamp: agentRes.timeStamp, // 必填，生成签名的时间戳
                            nonceStr: agentRes.nonceStr, // 必填，生成签名的随机串
                            signature: agentRes.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
                            jsApiList: jsApiList ? jsApiList : ["selectExternalContact"], //必填，传入需要使用的接口名称
                            success: function(res) {
                                console.log("调用接口成功")
                                console.log("开始回调")
                                callback(res);
                            },
                            fail: function(res) {
                                console.log("agentConfig异常")
                                console.log(res);
                                if (res.errMsg.indexOf("function not exist") > -1) {
                                    alert("版本过低请升级");

                                }
                            },
                        });
                    });

                });
            });
        };

        /**
         * 上传图片
         * @param {*}
         */
        Vue.prototype.uploadImage = function(file, callback, url, otherParams) {
            let formFile = new FormData();
            formFile.append("file", file);
            formFile.append("requireDomain", 1);
            // 如果有其它参数
            if (otherParams) {
                Object.keys(otherParams).forEach((key) => {
                    formFile.append(key, otherParams[key]);
                });
            }
            this.$http(
                url ? url : "/basedata/server/companyBaseDoc/uploadImage",
                formFile
            ).then((res) => {
                callback(res);
            });
        };

        /**
         * 得到用户名称
         * id反查汉字
         */
        (Vue.prototype.GetUserName = function(array, data) {
            let name = "";
            array.forEach((item) => {
                if (item.id == data) {
                    name = item.userName;
                }
            });
            return name;
        }),
        /**
         * 得到用户名
         */
        (Vue.prototype.GetStorageName = function() {
            const user = storage.getStorage("user");
            return user ? user.userName : "";
        }),
        /**
         * 得到用户名称
         * id反查汉字
         */
        (Vue.prototype.GetClearData = function() {
            Object.keys(this.searchData).forEach((key) => {
                this.searchData[key] = "";
            });
        }),
        /**
         * 返回上一页
         * -1,-2,-3
         *
         */
        (Vue.prototype.Back = function() {
            this.$router.back(-1);
        });

        /**
         * loading 隐藏
         */
        Vue.prototype.hideLoad = function() {
            Toast.clear();
        };

        /**
         *
         * 获取客户id
         * arry 表单数组
         */
        Vue.prototype.getClueId = function(callback, error) {
            this.wxLogin(() => {
                wx.invoke("getCurExternalContact", {}, (res) => {
                    console.log(res);
                    if (res.err_msg === "getCurExternalContact:ok") {
                        this.$http(
                            `/basedata/customer/clue/findClueByQywxOpenId`, { qywxOpenId: res.userId },
                            "get"
                        ).then((res) => {
                            if (res.id) {
                                callback(res.id);
                            } else {
                                if (error) {
                                    error();
                                }
                            }
                        });
                    } else {
                        this.Toast("请求失败，请稍后再试！");
                    }
                });
            }, ["getCurExternalContact"]);
        };

        /**
         * 更新编辑数据
         * obj 列表每行数据
         * arry 表单数组
         */
        Vue.prototype.updataForm = function(obj, arry) {
            arry.forEach((item) => {
                if (Object.keys(obj).includes(item.prop)) {
                    if (item.moment) {
                        //时间戳转换
                        item.value = obj[item.prop] ?
                            moment(obj[item.prop]).format("YYYY-MM-DD HH:mm:ss") :
                            "";
                    } else {
                        item.value = obj[item.prop];
                    }
                }
            });
            return arry;
        };

        /**
         * 更新编辑数据
         * obj 列表每行数据
         * data 对象
         */
        Vue.prototype.updataObjForm = function(obj, data) {
            Object.keys(obj).forEach((item) => {
                if (data[item]) {
                    obj[item] = data[item].toString();
                }
            });
            return obj;
        };

        /**
         * 重置表单
         * 数组类型重置[]
         * 字符串重置''
         */
        Vue.prototype.reloadForm = function(obj) {
            Object.keys(obj).forEach((item) => {
                obj[item] = obj[item] instanceof Array ? [] : "";
            });
        };

        /**
         * 得到数据字典数据
         * 隐患来源
         */
        Vue.prototype.gethdimSource = function(callback) {
            let arry = [],
                hdimSource = storage.getStorage("hdimSource");
            if (hdimSource) {
                //判断缓存是否存在当前数据，存在就取用缓存数据
                callback(hdimSource);
            } else {
                //隐患来源,隐患类型
                this.$http(
                    "base/dict/many?majorCode=hdimSource", {},
                    "get",
                    false
                ).then((res) => {
                    storage.setStorage("hdimSource", res.hdimSource);
                    if (callback) {
                        callback(res.hdimSource);
                    }
                });
            }
        };

        /**
         * 手机号码校验
         * @param phone
         * @returns {*}
         */
        Vue.prototype.errorMsg = function(value, msg) {
            let flag = false;
            if (!value) {
                Toast({
                    mask: false, //是否显示蒙版
                    message: msg,
                });
                flag = true;
            }
            return flag;
        };

        /**
         * 手机号码校验
         * @param phone
         * @returns {*}
         */
        Vue.prototype.isPhone = function(value) {
            if (!value) {
                Toast("请输入手机号");
                return 0;
            }
            var patterns = /^1[3,4,5,6,7,8,9]\d{9}$/;
            if (!patterns.test(value)) {
                Toast("请输入正确手机号");
                return 0;
            }
            return value;
        };

        /**
         * 4位验证码校验
         * @param Code
         * @returns {*}
         */
        Vue.prototype.isCode = function(value) {
            if (!isSetString(value)) {
                Toast("请输入验证码");
                return 0;
            }
            var reg = /^[0-9A-Za-z]{4}$/;
            if (!reg.test(value)) {
                Toast("手机验证码错误");
                return 0;
            } else {
                return value;
            }
        };
    },
};


// WEBPACK FOOTER //
// ./src/utils/util.js